var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendSmsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.7,
    height: 21.7,
    viewBox: "0 0 21.7 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send",
    transform: "translate(-1.15 -1.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2696",
    "data-name": "Group 2696"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M11,13.85a.85.85,0,0,1-.6-1.451l11-11a.85.85,0,0,1,1.2,1.2l-11,11A.847.847,0,0,1,11,13.85Z",
    fill: "#00246A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M22,1.15a.85.85,0,0,1,.8,1.131l-7,20a.85.85,0,0,1-1.579.064l-3.867-8.7-8.7-3.867A.85.85,0,0,1,1.719,8.2l20-7A.849.849,0,0,1,22,1.15ZM14.906,19.7l5.709-16.31L4.3,9.094l7.041,3.129a.85.85,0,0,1,.432.432Z",
    fill: "#00246A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSmsIcon);
export default __webpack_public_path__ + "static/media/sendSMSIcon.98a84203f53d14bb542866f24471c9f0.svg";
export { ForwardRef as ReactComponent };